export default __webpack_public_path__ + "static/media/preview_print.abec6b82.svg";